import { RydeUiUnit } from "../models";

/*
 * keep in sync with backend file libs/shared/src/helpers/migrations.helpers.ts
 * keep in sync with EditFormTemplateType & GridTemplateType
 */
export const FIELD_TYPE_IDS = {
  FORM: {
    addition_value: 59,
    address: 1,
    checkbox: 2,
    currency: 54,
    date: 3,
    date_range: 4,
    datetime: 5,
    datetime_range: 6,
    dropdown: 7,
    dropdown_bound: 8,
    email: 9,
    group_title: 10,
    section_title: 104,
    id_label: 11,
    map_polygon: 12,
    multiselect: 13,
    multiselect_bound: 14,
    number: 15,
    password: 16,
    phone: 17,
    price_rate_areas_pricing: 50,
    price_rate_distance_pricing: 53,
    price_rate_passengers_pricing: 51,
    price_rate_stations_pricing: 52,
    price_rate_addition_pricing_level: 102,
    relation_counters: 18,
    shift_template_cycle: 19,
    switch: 20,
    table_area_ratios: 21,
    table_availability: 62,
    table_station_hub: 99,
    table_contacts: 22,
    table_integrations: 23,
    table_time_schedule: 58,
    table_user_roles: 24,
    tags: 25,
    text: 26,
    textarea: 27,
    time: 28,
    time_range: 29,
    url: 30,
    station_dropdown: 69,
    radio_group: 72,
    html_info: 73,
    notification_read: 75,
    notification_content: 78,
    date_countdown_readonly: 80,
    link_to_another_entity_grid_filtered_by_current: 82,
    link_to_entity_card: 100,
    open_entity_form: 84,
    timezone_dropdown: 86,
    passenger_address: 87,
    neighbor_areas: 88,
    reset_password_system_manager: 90,
    custom_translations: 95,
    traffic_availability: 101,
    hidden_field: 103,
    rides_nested_grid: 107,
    recurring_production: 109,
    production_chain: 115,
    color_picker: 113,
    json_viewer: 123,
    hub_station_template: 131,
    hub_station_standalone_template: 132,
    catch_a_ride_availability: 139,
    data_upload_run_summary: 136,
    map_bounds: 137,
    site_dropdown: 138,
    area_waypoints: 140,
    boolean_image_icon: 142,
  },
  GRID: {
    address: 31,
    booking_status: 60,
    checkbox: 32,
    course_schedule: 61,
    csv_list: 33,
    currency: 55,
    date: 34,
    date_range: 35,
    date_with_indicator: 36,
    datetime: 37,
    datetime_range: 38,
    direction: 64,
    dropdown_bound_text: 57,
    email: 39,
    number: 40,
    phone: 41,
    ride_status: 66,
    switch: 42,
    switch_alternative: 43,
    switch_confirm: 44,
    tags: 45,
    text: 46,
    time: 47,
    time_range: 48,
    url: 49,
    vehicle_occupancy: 65,
    price_rate_pricing: 68,
    ride_start_end_datetime: 70,
    complaint_status: 71,
    action_button: 74,
    notification_priority: 76,
    date_countdown: 77,
    notification_grid_content: 79,
    entity_name: 81,
    entity_link: 83,
    open_entity_form: 85,
    feedback_status: 89,
    feedbacks_count: 93,
    ride_ml_path_indicator: 106,
    ride_passengers_csv_list: 94,
    ride_editable_dropdown_bound: 91,
    ride_editable_docks_dropdown: 116,
    plain_text: 92,
    currency_discount: 105,
    hidden_field: 108,
    warnings_display: 111,
    table_availability: 112,
    live_map_arrival_delay: 114,
    gps_indicator: 119,
    datetime_compact_readonly: 117,
    boolean_image_icon: 118,
    live_map_delay_status: 120,
    production_chain: 121,
    json_view: 122,
    live_map_ride_start_status: 124,
    hub_stations_grid_template: 130,
    booking_hub_grid_template: 133,
    ride_route_completion_status: 134,
    data_upload_run_button: 135,
    course_stations: 141,
  },
  FILTER: {
    multiselect: 63,
    multiselect_bound: 56,
    time: 67,
    number_between: 96,
    number_comparison: 97,
    free_text: 98,
  },
} as const;

export type FORM_FIELD_KEYS = keyof typeof FIELD_TYPE_IDS.FORM;
export type FORM_FIELD_VALUES = (typeof FIELD_TYPE_IDS.FORM)[FORM_FIELD_KEYS];
export type TGridFieldKeys = keyof typeof FIELD_TYPE_IDS.GRID;
export type TGridFieldValues = (typeof FIELD_TYPE_IDS.GRID)[TGridFieldKeys];
export type FILTER_FIELD_KEYS = keyof typeof FIELD_TYPE_IDS.FILTER;
export type FILTER_FIELD_VALUE_ID =
  (typeof FIELD_TYPE_IDS.FILTER)[FILTER_FIELD_KEYS];
export type FIELD_CATEGORY = keyof typeof FIELD_TYPE_IDS;

export const MATCHING_FIELD_FILTERS: Record<number, readonly number[]> = {
  [FIELD_TYPE_IDS.FORM.dropdown]: [FIELD_TYPE_IDS.FILTER.multiselect],
  [FIELD_TYPE_IDS.FORM.dropdown_bound]: [
    FIELD_TYPE_IDS.FILTER.multiselect_bound,
  ],
  [FIELD_TYPE_IDS.FORM.site_dropdown]: [
    FIELD_TYPE_IDS.FILTER.multiselect_bound,
  ],
} as const;

export const GRID_DATETIME_FIELD_KEYS = [
  "date",
  "date_with_indicator",
  "datetime",
  "datetime_compact_readonly",
  "time",
];

export const UPDATE_DROPDOWN_FROM_METADATA_FIELD_KEYS = new Set(["tags"]);
export const FORM_FIELD_TYPE_NAME_TO_RYDE_UI_UNIT: Partial<
  Record<FORM_FIELD_KEYS, RydeUiUnit>
> = {
  tags: "systemTag",
};

export const FILTERABLE_FORM_FIELDS: number[] = [
  FIELD_TYPE_IDS.FORM.dropdown,
  FIELD_TYPE_IDS.FORM.dropdown_bound,
  FIELD_TYPE_IDS.FORM.site_dropdown,
];
export const MULTISELECT_FORM_FIELDS: FORM_FIELD_VALUES[] = [
  FIELD_TYPE_IDS.FORM.multiselect,
  FIELD_TYPE_IDS.FORM.multiselect_bound,
  FIELD_TYPE_IDS.FORM.tags,
];

export const FILTERABLE_FILTER_BASIC_FIELDS = new Set<FILTER_FIELD_VALUE_ID>([
  FIELD_TYPE_IDS.FILTER.time,
  FIELD_TYPE_IDS.FILTER.number_between,
  FIELD_TYPE_IDS.FILTER.number_comparison,
  FIELD_TYPE_IDS.FILTER.free_text,
]);
